import { render, staticRenderFns } from "./consignmentHis.vue?vue&type=template&id=39e68221&scoped=true"
import script from "./consignmentHis.vue?vue&type=script&lang=js"
export * from "./consignmentHis.vue?vue&type=script&lang=js"
import style0 from "./consignmentHis.vue?vue&type=style&index=0&id=39e68221&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e68221",
  null
  
)

export default component.exports